import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  AttachmentSlider,
  Button,
  ButtonIcon,
  CommentCardNew,
  FormHeader,
  InputBox,
  PageNavigation,
  SuggestNewsCard,
  Tag,
  TextArea,
  TopMenu,
} from "../../components";
import Menu from "../templates/menu";
import {
  getJobsByTags,
  getNewsById,
  getNewsByTags,
  getNextNewsById,
} from "./service/news.service";
import Footer from "../footer/index";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { setViewNews } from "../news/redux/actions";
import { GetIconByName } from "../../config/icon";
import { openMobileMenuModal, setNewsUser } from "../console/redux/actions";
import {
  EmailChangeModal,
  EmailVerificationModal,
  MobileMenuModal,
} from "../modal";
import { Helmet } from "react-helmet";
import { getIPAddress } from "../../utils/browserMeta";
import { getInsight, setAdsSession, setInsight } from "../../utils/auth";
import {
  createNewInsight,
  createNewsImpression,
} from "../console/services/insight.service";
import {
  ConsoleTopLeftAdd,
  ConsoleTopRightAdd,
  HomePageCenterAdd,
  NewsViewLeftBottomAdd,
  NewsViewRightTopAdd,
} from "../templates/advertiesments";

import RelatedNews from "../templates/relatedNews";
import CategoryNewsSmall from "../templates/categoryNewsSmall";
import { useLocation } from "react-router-dom";
import SuggestionsNews from "../templates/suggestionsNews";
import useTags from "../../config/tags";
import { Dropdown, notification } from "antd";
import { CheckValidity } from "../../utils";
import { Store } from "react-notifications-component";
import { addNewsComment } from "../news/service/news.service";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import {
  createNewAdsCompany,
  createNewEmailVerification,
} from "../AdsSignUp/services/adsSignup.service";
import { getExistingByUserName } from "../AdsSignIn/service/auth.service";
import { openEmailVerificationModal } from "../AdsPlatform/redux/actions";
import OffersPreview from "../templates/offersPreviewing";
import OffersPreviewRight from "../templates/offersPreviewingRight";
import HomeAdViewModal from "../modal/homeAdViewModal";
import RelatedWidget from "../templates/relatedWidget";
import GazetteCard from "../templates/newGazetteJobCard";
import NewGazetteJobCard from "../templates/newGazetteJobCard";

const lan = getLanguage();

const Index = ({ props, commentsLength, data }) => {
  const [category, setCategory] = React.useState("");

  const [news, setNews] = React.useState("");
  const [currentUrl, setCurrentUrl] = React.useState("");
  const [newsUpdateList, setNewsUpdateList] = React.useState([]);
  const [jobsUpdateList, setJobsUpdateList] = React.useState([]);
  const [newsWidgetId, setNewsWidgetId] = React.useState("");
  const [newsId, setNewsId] = React.useState("");
  const [nextNews, setNextNews] = React.useState("");
  const [previousNews, setPreviousNews] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showAllComments, setShowAllComments] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [isSecond, setIsSecond] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const [formData, setFormData] = React.useState({
    firstName: {
      key: "firstName",
      label: "First name",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "How we call you",
      },
      validation: {
        required: true,
      },
      touched: false,
      isValid: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    email: {
      key: "email",
      label: "Working email address",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "Enter you working email address",
      },
      validation: {
        required: true,
        email: true,
      },
      touched: false,
      isValid: false,
      isLoading: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    comment: {
      key: "comment",
      label: "",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "Write a comment here",
      },
      touched: false,
      validation: {
        required: false,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    newsUrl: {
      key: "newsUrl",
      label: "",
      size: "lg disable mt-3",
      elementConfig: {
        type: "text",
        placeholder: "",
        disable: true,
      },
      disabled: true,
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const dispatch = useDispatch();
  const history = useHistory();
  const { isOpenMobileMenuModal, newsUser, isOpenAd } = useSelector(
    ({ consoleReducer }) => consoleReducer,
  );
  const { isOpenEmailVerificationModal, isOpenEmailChangeModal } = useSelector(
    ({ adsUserReducer }) => adsUserReducer,
  );

  const handleChange = async (event, inputIdentity) => {
    const updateContactForm = {
      ...formData,
    };

    updateContactForm[inputIdentity].value = event;

    let validityRes = await CheckValidity(
      inputIdentity,
      updateContactForm[inputIdentity].value,
      updateContactForm[inputIdentity].validation,
    );
    if (validityRes) {
      updateContactForm[inputIdentity].isValid = validityRes.isValid;
      updateContactForm[inputIdentity].invalidReason = validityRes.reason;
      updateContactForm[inputIdentity].touched = true;

      // updateContactForm[inputIdentity] = updatedFormElement;
      let formIsValid = false;
      for (let inputIdentifier in updateContactForm) {
        formIsValid = updateContactForm[inputIdentifier].valid && formIsValid;
      }

      setFormData(updateContactForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = {
      ...formData,
    };
    for (let key in updateNewsForm) {
      if (key === "newsUrl") {
        continue;
      }
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setFormData(updateNewsForm);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY >= 20);
      // console.log(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const updateContactForm = { ...formData };

  const { getTagName } = useTags();
  const location = useLocation();

  async function handleInsight(newsId, categoryId) {
    let insightBody = {};
    try {
      console.log({ newsId, categoryId });
      // Get the geolocation
      // const position = await getGeoLocation();
      // const { latitude, longitude, accuracy, timestamp } = position?.coords;

      // Wait for all promises to resolve
      const [ip] = await Promise.all([
        // getLocationName(latitude, longitude),
        getIPAddress(),
      ]);

      // Construct the insight body
      insightBody = {
        insight_id: null,
        ip,
        platform: "https://hopeofanewera.org/",
        // user: sessionUser?.userId,
      };

      console.log("userInsight_insightBody:", insightBody);
      const insight = await getInsight();
      console.log("Insight found", insight);
      // Additional logic for when the insight is found
      if (insight?.insight_id) {
        console.log("userInsight_insight_found", insight);
        insightBody.insight_id = insight.insight_id;
        let impressionBody = {
          insight_id: insight.insight_id,
          news_id: newsId,
          category_id: categoryId,
          ip_address: ip,
        };

        let resImpression = await createNewsImpression(impressionBody);
        console.log("userInsight_insightImpression", resImpression);
        // setNews({ ...news, views: (news?.views || 0) + 1 });
      }
    } catch (error) {
      console.log("No insight found", error);
      try {
        const insightResponse = await createNewInsight(insightBody);
        console.log("Created new insight:", insightResponse);
        if (
          insightResponse?.data?.status ||
          insightResponse?.data?.data !== ""
        ) {
          await setInsight(insightResponse?.data?.data?.token);
          let impressionBody = {
            insight_id: insightResponse?.data?.data?.insight_id,
            news_id: newsId,
            category_id: categoryId,
            ip_address: insightBody.ip,
          };

          let resImpression = await createNewsImpression(impressionBody);
          console.log("userInsight_insightImpression", resImpression);
          // setNews({ ...news, views: (news?.views || 0) + 1 });
        }

        // Additional logic for when the insight is not found and a new one is created
      } catch (creationError) {
        console.error("Error creating new insight:", creationError);
        // Handle the error that occurred during the creation of a new insight
      }
    }
  }

  async function fetchPageData() {
    let param = window.location.pathname.split("/");
    console.log({ param });

    if (param.length > 2) {
      const newsIdPram = param[2];

      let updateFormData = { ...formData };

      updateFormData["newsUrl"].value =
        lan === "si"
          ? "https://sinhala.hopeofanewera.org/" +
            decodeURIComponent(param[1])?.toString() +
            "/" +
            newsIdPram
          : "https://hopeofanewera.org/" +
            decodeURIComponent(param[1])?.toString() +
            "/" +
            newsIdPram;
      setCurrentUrl(
        lan === "si"
          ? "https://sinhala.hopeofanewera.org/" +
              decodeURIComponent(param[1])?.toString() +
              "/" +
              newsIdPram
          : "https://hopeofanewera.org/" +
              decodeURIComponent(param[1])?.toString() +
              "/" +
              newsIdPram,
      );

      try {
        setNewsId(newsIdPram);
        const response = await getNewsById(newsIdPram, lan);

        console.log("get news", response);
        if (response?.data) {
          const news = response?.data;
          console.log("get news comments", news?.comments);
          // if news's updates array is not null then set news from updates from latest news in array
          // else set news from news object
          // if (news?.updates?.length > 0) {
          //   setNews(news?.updates?.[news?.updates?.length - 1]);
          //   dispatch(setViewNews(news?.updates?.[news?.updates?.length - 1]));
          //   setFullNews(news);
          //   setNewsUpdateList(news?.updates);
          // } else {

          // If no keyword exists for the current language, generate from title
          if (!news.keywords?.[lan] || news.keywords[lan].trim() === "") {
            const generatedSlug = news.title?.[lan]
              ?.toLowerCase() // make lowercase
              ?.replace(/[\u200B-\u200D\uFEFF]/g, "") // remove zero-width chars
              ?.replace(/[^a-z0-9\s-]/g, "") // keep only letters, numbers, spaces, and dashes
              ?.trim()
              .replace(/\s+/g, "-") // replace spaces with dashes
              .replace(/-+/g, "-"); // Remove duplicate dashes

            console.log({ generatedSlug });

            // Update browser URL without reload
            if (generatedSlug) {
              window?.history?.replaceState(
                {},
                "",
                `/${encodeURIComponent(generatedSlug)}/${newsIdPram}`,
              );
            } else {
              window?.history?.replaceState(
                {},
                "",
                `/${param[1]}/${newsIdPram}`,
              );
            }

            // Optionally, update `keywords` in state
            news.keywords = {
              ...(news.keywords || {}),
              [lan]: generatedSlug,
            };
          }
          setNews(news);
          setNewsWidgetId(news?.widget);
          setFormData(updateFormData);
          dispatch(setViewNews(news));
          await fetchNewsByTags(news?.tags);
          await fetchNextAndPreviousNews(news?.news_id);
          // setFullNews("");
          // setNewsUpdateList([]);
          // }
          userInsight(news?.news_id, news?.category);
        } else {
          console.log("get news-not-found", response);
          setNews("");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  }

  async function userInsight(news_id, category_id) {
    let param = window.location.pathname.split("/");
    try {
      if (param.length > 2) {
        const newsId = param[2];
        const categoryId = param[3] || category_id;
        // Fetch existing insight if it exists
        await handleInsight(news_id, categoryId);
      }
    } catch (error) {
      console.error("Error in userInsight:", error);
    }
  }

  useEffect(() => {
    if (updateContactForm?.comment.value === "") {
      setIsOpen(false);
    }
  }, [updateContactForm?.comment.value]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  useEffect(() => {
    let param = window.location.pathname.split("/");

    const newsIdPram = param?.[2];
    if (newsId !== newsIdPram || newsId === "") {
      fetchPageData();
    }
  }, [window.location.pathname]);

  const fetchNewsByTags = async (tag_list) => {
    let param = window.location.pathname.split("/");
    let news_id = param?.[2];
    if (tag_list?.length > 0) {
      let result = await getNewsByTags(lan, { tag_ids: tag_list });
      let result_tags = await getJobsByTags({ tag_ids: tag_list });
      console.log("tag jobs::", result_tags);
      console.log("tag news::", result?.data?.news);
      if (result?.data?.news?.length > 0) {
        let newsList = result?.data?.news;

        // if (
        //   newsList?.length === 1 &&
        //   newsList?.find((news) => news?.news_id === news_id)
        // ) {
        //   setNewsUpdateList(
        //     newsList?.filter((x) => x.news_id !== news_id)?.map((x) => x)
        //   );
        //   return;
        // }
        setNewsUpdateList(result?.data?.news);
      } else {
        setNewsUpdateList([]);
      }
      if (result_tags?.data?.jobs?.length > 0) {
        let jobsList = result_tags?.data?.jobs;

        setJobsUpdateList(jobsList);
      } else {
        setJobsUpdateList([]);
      }
    }
  };

  const fetchNextAndPreviousNews = async (news_id) => {
    if (news_id) {
      let result_next = await getNextNewsById(lan, news_id, 1);
      let result_previous = await getNextNewsById(lan, news_id, 0);

      console.log("result_previous", result_previous);
      console.log({ result_next }, { result_previous });
      if (result_next?.data || result_next?.data?.news) {
        setNextNews(result_next?.data);
        setPreviousNews(result_previous?.data);
      } else {
        setNextNews("");
        setPreviousNews("");
      }
    } else {
      setNextNews("");
      setPreviousNews("");
    }
  };

  const handleCopy = () => {
    let param = window.location.pathname.split("/");
    let keyword = param?.[1];
    const actualUrl =
      lan === "si"
        ? "https://sinhala.hopeofanewera.org/" +
          decodeURIComponent(keyword)?.toString() +
          "/" +
          newsId
        : "https://hopeofanewera.org/" +
          decodeURIComponent(keyword)?.toString() +
          "/" +
          newsId;
    navigator.clipboard.writeText(actualUrl).then(() => {
      notification.success({ message: "Link copied to clipboard!" });
    });
  };

  const handleChildData = (childData) => {
    // props.onChangeCategory(childData); // Update state with child data
    setCategory(childData);
  };

  // play youtube news
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;

    // Handle shortened youtu.be links
    if (url.includes("youtu.be/")) {
      return `https://www.youtube.com/embed/${url.split("youtu.be/")[1]}`;
    }

    // Handle standard youtube.com links
    if (url.includes("watch?v=")) {
      return url.replace("watch?v=", "embed/");
    }

    return url;
  };

  useEffect(() => {
    if (newsUser?.company_id) {
      let updateFromData = { ...formData };

      updateFromData["email"].value = newsUser?.working_email;
      updateFromData["firstName"].value = newsUser?.company_name;
      setFormData(updateFromData);
    }
  }, [newsUser]);

  const onClickAddComment = async () => {
    setIsLoading(true);

    const updateForm = { ...formData };
    let insight = await getInsight();

    try {
      let isExisting = await getExistingByUserName({
        email: updateForm.email.value,
      });
      console.log("isExisting", isExisting);
      if (isExisting?.data?.status) {
        if (!isExisting?.data?.data?.isAccountVerified) {
          let resVerify = await createNewEmailVerification({
            company_id: isExisting?.data?.data?.company_id,
            email: isExisting?.data?.data?.working_email,
          });
          console.log("resVerify", resVerify.data);
          if (resVerify.data.status) {
            setAdsSession(resVerify.data?.data?.token);
            setIsLoading(false);
            dispatch(
              openEmailVerificationModal({
                user: isExisting?.data?.data,
                token: resVerify.data?.data?.token,
              }),
            );

            window.scrollTo({ top: 0, behavior: "smooth" });
          } else {
            notification.error({
              message: "Error",
              description: resVerify.data.message,
            });
            setIsLoading(false);
          }
        } else {
          const response = await addNewsComment(
            {
              insight_id: insight?.insight_id || null,
              first_name: updateForm.firstName.value,
              email: updateForm.email.value,
              comment: updateForm.comment.value,
            },
            newsId,
          );

          if (response.data?.status) {
            setIsLoading(false);
            setIsOpen(false);
            // await saveUserCompany();
            await fetchPageData();
            clearAll();
          } else {
            setIsLoading(false);
            Store.addNotification({
              title: "Error!",
              message: response?.data?.message || "Feedback sending Failed!",
              type: "danger",
              insert: "top",
              container: "top-right",
              dismiss: {
                duration: 3000,
                onScreen: true,
              },
            });
          }
        }
      } else {
        try {
          await saveUserCompany();
        } catch (error) {
          console.error({ error });
        }
        const response = await addNewsComment(
          {
            insight_id: insight?.insight_id || null,
            first_name: updateForm.firstName.value,
            email: updateForm.email.value,
            comment: updateForm.comment.value,
          },
          newsId,
        );

        if (response.data?.status) {
          setIsLoading(false);
          setIsOpen(false);
          await fetchPageData();
          clearAll();
        } else {
          setIsLoading(false);
          Store.addNotification({
            title: "Error!",
            message: response?.data?.message || "Feedback sending Failed!",
            type: "danger",
            insert: "top",
            container: "top-right",
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
        }
      }
    } catch (error) {
      setIsLoading(false);
      Store.addNotification({
        title: "Error!",
        message: "Feedback sending Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  const saveUserCompany = async () => {
    setIsLoading(true);
    let updateFormData = { ...formData };

    let body = {
      company_name: updateFormData.firstName.value,
      company_logo: "",
      company_website: "",
      working_email: updateFormData.email.value,
      password: "user@123",
      contact_no: "",
      company_type: "user",
    };

    try {
      let res = await createNewAdsCompany(body);
      console.log("res", res);
      if (res?.data?.status) {
        setIsLoading(false);
        // setUserSession(res?.data?.token);
        let resVerify = await createNewEmailVerification({
          company_id: res?.data?.data?.company_id,
          email: res?.data?.data?.working_email,
        });
        console.log("resVerify", resVerify.data);
        if (resVerify.data.status) {
          setAdsSession(resVerify.data?.data?.token);
          // props.history.push("/ads/verification");
          dispatch(
            openEmailVerificationModal({
              user: res?.data?.data,
              token: resVerify.data?.data?.token,
            }),
          );
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          notification.error({
            message: "Error",
            description: resVerify.data.message,
          });
        }
        dispatch(setNewsUser(res?.data?.data));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };

  const addComment = (
    <div className={"contact-form news"}>
      <div
        className="common-modal-close"
        style={{
          marginTop: "-16px",
        }}
      >
        <ButtonIcon
          data={{ iconName: "cross", size: "sm" }}
          onClick={() => {
            setIsOpen(false);
            setIsLoading(false);
          }}
        />
      </div>
      <InputBox
        data={updateContactForm.firstName}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateContactForm.firstName.key);
        }}
      />
      <InputBox
        data={updateContactForm.email}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateContactForm.email.key);
        }}
      />
      <Button
        data={{
          mainLayerStyles: "mt-3",
          btnName: "Done",
          buttonType:
            updateContactForm.firstName.value === "" ||
            updateContactForm.email.value === "" ||
            updateContactForm.comment.value === ""
              ? "primary disabled"
              : "primary",
          buttonSize: "lg",
          isLoading: isLoading,
          disable:
            updateContactForm.firstName.value === "" ||
            updateContactForm.email.value === "" ||
            updateContactForm.comment.value === ""
              ? true
              : false,
        }}
        onClick={async () => {
          try {
            await onClickAddComment();
          } catch (err) {
            setIsLoading(false);

            console.error(
              "Comment add failed:",
              err,
              updateContactForm.firstName.value === "" ||
                updateContactForm.email.value === "" ||
                updateContactForm.comment.value === "",
            );
          }
        }}
      />
    </div>
  );

  useEffect(() => {
    const handleScroll = () => {
      setIsSecond(window.scrollY >= 350);
      setIsBottom(window.scrollY >= 950);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const currentUrl = window.location.href;
  const title = encodeURIComponent(news?.title?.[lan] || "Hope of a New Era");
  const image = encodeURIComponent(
    news?.images?.[0]?.url || news?.youtube_url || "",
  );

  const sortedComments = [...(news?.comments || [])].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
  );

  const displayedComments = showAllComments
    ? [...(news?.comments || [])]?.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      )
    : sortedComments.slice(0, 2);

  return (
    <>
      {isOpenMobileMenuModal && <MobileMenuModal />}
      {isOpenEmailVerificationModal && <EmailVerificationModal />}
      {isOpenEmailChangeModal && <EmailChangeModal />}
      {isOpenAd && <HomeAdViewModal />}
      <Helmet>
        <title>{news?.title?.[lan]}</title>
        <meta
          name="description"
          content={news?.summary?.[lan]?.slice(0, 150)}
        />
        <meta property="og:title" content={news?.title?.[lan]} />
        <meta
          property="og:description"
          content={news?.summary?.[lan]?.slice(0, 150)}
        />
        <meta property="og:image" content={news?.images?.[0]?.url} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={news?.title?.[lan]} />
        <meta
          name="twitter:description"
          content={news?.summary?.[lan]?.slice(0, 150)}
        />
        <meta name="twitter:image" content={news?.images?.[0]?.url} />

        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: news?.title?.[lan],
            image: [news?.images?.[0]?.url],
            datePublished: news?.created_at,
            dateModified: news?.updated_at || news?.created_at,
            author: {
              "@type": "Organization",
              name: "Hope of a New Era",
            },
            publisher: {
              "@type": "Hope of a New Era",
              name: "Hope of a New Era",
              logo: {
                "@type": "ImageObject",
                url: "https://example.com/logo.png",
              },
            },
          })}
        </script>
      </Helmet>
      <>
        {/* <div className={"bg-image"}></div>{" "} */}
        {/* <img className={"bg__img"} src={news?.images?.[0]?.url} alt={""} /> */}

        <div className={`cw__top-menu ${isSticky ? "sticky" : ""}`}>
          <TopMenu
            data={{
              size: "lg",
              isLanguage: true,
              isLogo: false,
              isProfile: false,
            }}
            onClick={() => {
              history.push("/");
            }}
            onClickPublish={() => {
              history.push("/admin");
            }}
          />
        </div>
        <div className={"container"}>
          <div className={`cw__tab ${isSticky ? "sticky" : ""}`}>
            <div className={"cwt__hope"}>
              {/* නවයුගයක පැතුමක් */}
              <img
                src={require("../../assets/img/lgo (1).png")}
                alt={news?.title?.[lan]}
                //style={{ marginRight: "17px" }}
              />
            </div>
            <div className={"menu"}>
              <Menu setMenuName={handleChildData} />
            </div>

            {/* <div
              className={"cwt__menu-mobile"}
              onClick={() => {
                dispatch(openMobileMenuModal());
              }}
            >
              {GetIconByName("menu")}
            </div> */}
          </div>
          <div className={"cw__advertiesment-wrapper"}>
            {/* <div className={"cwa__advertiesment"}>Advertisement with us </div>
            <div className={"cwa__advertiesment"}>Advertisement with us </div> */}
            <div className={"cwaw__first"}>
              <ConsoleTopLeftAdd />
            </div>
            <ConsoleTopRightAdd />
          </div>
          <PageNavigation
            data={{
              main: "Home",
              page: news?.title?.[lan],
            }}
            onClick={() => history.push("/")}
          />

          <div className={`news-view-wrapper mt-2`}>
            <div className={"nw__special-news-group"} style={{ gap: "8px" }}>
              {news?.youtube_url ? (
                <div class={`mb-3`}>
                  <iframe
                    width="100%"
                    height="545"
                    // src={news?.youtube_url}
                    // src={news?.youtube_url.replace("watch?v=", "embed/")}
                    src={getYouTubeEmbedUrl(news?.youtube_url)}
                    // title="${video.name}"
                    title={news?.title?.[lan]}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              ) : (
                <></>
                // <img
                //   src={news?.images?.[0]?.url}
                //   alt={news?.title?.[lan]}
                //   className={"nwsng__img"}
                // />
              )}
              <FormHeader
                data={{
                  formHeader: news?.title?.[lan],
                  size: "view-header",
                  lan: lan,
                }}
              />

              <div className="d-flex flex-row align-items-center">
                <div className={"nwsng__date"}>
                  {moment(news?.created_at).format("MMMM Do YYYY")}
                </div>
                <div className="d-flex p-2">
                  <Tag
                    data={{
                      isIcon: true,
                      tagIcon: "eye",
                      tagName: news?.views,
                      type: "views_tag",
                    }}
                  />
                </div>
              </div>
              {/* <div className={"nwsng__advertiesment"}>
                Advertisement with us{" "}
              </div> */}
              {/* <NewsViewLeftTopAdd /> */}
              <div id="container-12e03264376f1867506e14bf4ff8a092"></div>
              {news?.content && (
                <div
                  className={"nwsng__content"}
                  dangerouslySetInnerHTML={{
                    __html: news?.content?.[lan],
                  }}
                ></div>
              )}
              {news?.tags?.length > 0 && (
                <div className={"nwsng__tags d-flex flex-row flex-wrap"}>
                  {news?.tags?.length > 0 &&
                    news?.tags.map((tags, index) => (
                      <div
                        className="nwsng__date click"
                        onClick={() => {
                          history.push(
                            `/tag/${getTagName(tags)?.name}/${tags}`,
                          );
                          // props.onChangeTag({
                          //   tag_name: getTagName(tags)?.name,
                          //   tag_id: tags,
                          // });
                        }}
                      >
                        #{getTagName(tags)?.name}
                      </div>
                    ))}
                </div>
              )}
              {news?.attachments?.length > 0 && (
                <div className="section_wrapper">
                  <div className="nwsng__share mb-4"> Attachments</div>
                  <AttachmentSlider
                    file_type={"pdf"}
                    attachments={news?.attachments}
                  />
                </div>
              )}
              {news?.gallery?.length > 0 && (
                <div className="section_wrapper mt-3">
                  <div className="nwsng__share mb-4"> Gallery</div>
                  <AttachmentSlider
                    file_type={"image"}
                    attachments={news?.gallery}
                  />
                </div>
              )}
              {/* related news */}
              {newsUpdateList?.length > 0 && (
                <RelatedNews
                  newsList={newsUpdateList}
                  news_id={news?.news_id}
                  is_title={false}
                />
              )}

              {/*related widget news*/}
              <RelatedWidget
                widgetId={newsWidgetId}
                news_id={news?.news_id}
                is_title={true}
              />

              {jobsUpdateList?.length > 0 && (
                <RelatedNews
                  newsList={jobsUpdateList}
                  title={"Related Jobs"}
                  news_id={news?.news_id}
                  is_jobs={true}
                />
              )}

              {/* share section */}
              {/*Iframe sync*/}

              <div className={"share_section_wrapper"}>
                <div className="d-flex flex-column mt-3">
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <div className="nwsng__share mb-1"> Share</div>
                    <div className={"nw__social"}>
                      <div className={"nws__logo"}>
                        <a
                          href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nws__l-icon"
                        >
                          {GetIconByName("facebook")}
                        </a>
                      </div>
                      <div className={"nws__logo"}>
                        <a
                          href={`https://twitter.com/intent/tweet?text=${title}&url=${currentUrl}&hashtags=HopeOfANewEra&via=HopeNews`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nws__l-icon"
                        >
                          {GetIconByName("twitter")}
                        </a>
                      </div>
                      <div className={"nws__logo"}>
                        <a
                          href={`https://api.whatsapp.com/send?text=${title}%20${currentUrl}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nws__l-icon"
                        >
                          {GetIconByName("whatsapp")}
                        </a>
                      </div>
                    </div>
                  </div>
                  <InputBox
                    data={updateContactForm.newsUrl}
                    onChange={async (e) => {
                      e.preventDefault();
                    }}
                  />{" "}
                  <div
                    onClick={handleCopy}
                    style={{ cursor: "pointer" }}
                    title="Copy Link"
                    className={"nws__copy"}
                  >
                    {window.innerWidth < 440 ? "Copy" : "Copy Link"}
                  </div>
                </div>
              </div>
              {/* Comment Section New */}
              <div className={"comment_section_wrapper"}>
                <div>
                  <label className="nwsng__share comment_section">
                    ({news?.comments?.length || 0}) Comments -{" "}
                    {news?.title?.[lan]}
                  </label>
                  <TextArea
                    data={updateContactForm.comment}
                    onChange={async (e) => {
                      e.preventDefault();
                      await handleChange(
                        e.target.value,
                        updateContactForm.comment.key,
                      );
                    }}
                  />
                  <div className="submit_btn">
                    <Dropdown
                      overlay={addComment}
                      placement="bottomLeft"
                      trigger={["click"]}
                      open={isOpen}
                    >
                      <Button
                        data={{
                          mainLayerStyles: "",
                          btnName: "SUBMIT",
                          buttonType:
                            updateContactForm.comment.value === ""
                              ? "primary disabled"
                              : "primary",
                          buttonSize: "sm-x",
                          isLoading: isLoading,
                          disable:
                            updateContactForm.comment.value === ""
                              ? true
                              : false,
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          setIsOpen(!isOpen);
                          // await onClickAddComment(e);
                        }}
                      />
                    </Dropdown>
                  </div>
                </div>
                {news?.comments?.length === 0 ? (
                  <div className={"no__comments"}>
                    <div className={"nc__icon"}>
                      {GetIconByName("comments")}
                    </div>
                    <div className={"nc__title"}>
                      No comments yet. Be the first to leave feedback on this
                      endpoint
                    </div>
                  </div>
                ) : (
                  <div className={"mt-2"}>
                    {news?.comments?.length > 0 &&
                      displayedComments
                        ?.filter((comment) => comment?.status !== "hide")
                        .map((comment, index) => (
                          <CommentCardNew
                            data={{
                              first_name: comment?.first_name,
                              email: comment?.email,
                              comment: comment?.comment,
                            }}
                            comment={comment}
                            index={index}
                            newsId={newsId}
                          />
                        ))}
                    {/* <CommentCardNew
                    data={{
                      first_name: "Jhon",
                      email: "john123@gmail.com",
                      comment:
                        "ඉල්ලන් කෑමේ ආරම්භය, අල්ලපු රටේ සදාම් හුසේනුත් මේ වගේම ඉල්ලන් කාලා රටත් විනාස කර ගත්තා.",
                    }}
                  /> */}
                  </div>
                )}
                {news?.comments?.length > 2 && (
                  <div
                    className={
                      "d-flex flex-row justify-content-center align-items-center"
                    }
                    style={{ marginTop: "12px", marginBottom: "33px" }}
                  >
                    <div
                      className={"show__more"}
                      onClick={() => setShowAllComments(!showAllComments)}
                    >
                      {showAllComments
                        ? "Show Less"
                        : `Show More (${news?.comments?.length - 2})`}
                    </div>
                  </div>
                )}
              </div>
              {/* Comment section */}
              {/* <div className="d-flex flex-row justify-content-between align-items-center">
                <Dropdown
                  overlay={addComment}
                  placement="bottomLeft"
                  trigger={["click"]}
                  open={isOpen}
                >
                  <div className="d-flex">
                    <Button
                      data={{
                        mainLayerStyles: "mt-3",
                        btnName: "Add Comment ",
                        buttonType: "secondary s-border x",
                        buttonSize: "xs",
                        disable: false,
                        btnIcon: GetIconByName("comment"),
                        buttonIcon: true,
                      }}
                      onClick={() => {
                        setIsOpen(!isOpen);
                        // dispatch(openNewsCommentModal(news));
                      }}
                    />
                  </div>
                </Dropdown>
                <div className="d-flex flex-column pr-3">
                  <div className="nwsng__content mb-1"> Share with: </div>
                  <div className={"nw__social"}>
                    <div className={"nws__logo"}>
                      <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nws__l-icon"
                      >
                        {GetIconByName("facebook")}
                      </a>
                    </div>
                    <div className={"nws__logo"}>
                      <a
                        href={`https://twitter.com/intent/tweet?text=${title}&url=${currentUrl}&hashtags=HopeOfANewEra&via=HopeNews`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nws__l-icon"
                      >
                        {GetIconByName("twitter")}
                      </a>
                    </div>
                    <div className={"nws__logo"}>
                      <a
                        href={`https://api.whatsapp.com/send?text=${title}%20${currentUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nws__l-icon"
                      >
                        {GetIconByName("whatsapp")}
                      </a>
                    </div>
                    <div
                      onClick={handleCopy}
                      style={{ cursor: "pointer" }}
                      title="Copy Link"
                      className={"nws__logo"}
                    >
                      <div className="nws__l-icon">{GetIconByName("link")}</div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className={"nwsng__comment"}>
                <div className={"nwsng__action"}>
                  <div className={"nwsng__inner_action_"}>
                    {previousNews?.news_id && (
                      <SuggestNewsCard
                        data={{
                          type: "previous",
                          header: lan === "en" ? "Previous News" : "කලින් පුවත",
                          title:
                            previousNews?.title?.[lan]?.length > 60
                              ? previousNews?.title?.[lan]?.slice(0, 60) + "..."
                              : previousNews?.title?.[lan],
                          imgurl: previousNews?.images?.[0]?.url,
                          created_at: previousNews?.created_at,
                        }}
                        onClick={() => {
                          const generatedSlug = previousNews?.title?.[lan]
                            ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                            ?.replace(/\//g, "")
                            ?.replace(/\s*-\s*/g, " ")
                            ?.trim()
                            .split(/\s+/)
                            .slice(0, 5)
                            .join("-")
                            .replace(/-+/g, "-");
                          history.push(
                            `/${generatedSlug}/${previousNews?.news_id}`,
                          );
                        }}
                      />
                    )}
                  </div>
                  <div className={"nwsng__inner_action_"}>
                    {nextNews?.news_id && (
                      <SuggestNewsCard
                        data={{
                          type: "next",
                          header: lan === "en" ? "Next News" : "මීළඟ පුවත",
                          title:
                            nextNews?.title?.[lan]?.length > 60
                              ? nextNews?.title?.[lan]?.slice(0, 60) + "..."
                              : nextNews?.title?.[lan],
                          imgurl: nextNews?.images?.[0]?.url,
                          created_at: nextNews?.created_at,
                        }}
                        onClick={() => {
                          const generatedSlug = nextNews?.title?.[lan]
                            ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                            ?.replace(/\//g, "")
                            ?.replace(/\s*-\s*/g, " ")
                            ?.trim()
                            .split(/\s+/)
                            .slice(0, 5)
                            .join("-")
                            .replace(/-+/g, "-");
                          history.push(
                            `/${generatedSlug}/${nextNews?.news_id}`,
                          );
                        }}
                      />
                    )}
                  </div>
                </div>

                {/* new 3 jobs */}
                <NewGazetteJobCard title="Goverment jobs" is_gazette={false} />

                {/* new 2 gazette */}
                <NewGazetteJobCard title="Gazette" is_gazette={true} />

                <div className="cwaw__bottom">
                  <NewsViewLeftBottomAdd />
                </div>
                <div className="cwaw__mobile">
                  <HomePageCenterAdd />
                </div>
                <div className="mt-2 mb-2">
                  <OffersPreview count={4} active={isBottom} />
                </div>
                <div className={"mt-4"}>
                  <SuggestionsNews news_id={news?.news_id} no_of_news={"1"} />
                </div>
              </div>
            </div>

            <div className={"nw__special-news-group"} style={{ gap: "12px " }}>
              {/* <div className={"home__advertiesment mb-3"}>
                Advertisement with us
              </div> */}
              <NewsViewRightTopAdd data={{ mainLayerStyles: "mb-3" }} />
              {/* <HotNewsSmall setMenuName={handleChildData} /> */}
              <CategoryNewsSmall
                setMenuName={handleChildData}
                categoryId={news?.category}
                news_id={news?.news_id}
              />
              <div>
                <OffersPreviewRight count={4} active={isSecond} />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    </>
  );
};

export default withRouter(Index);
